import { render, staticRenderFns } from "./rmb_central_parities.vue?vue&type=template&id=64c0a08e&scoped=true"
import script from "./rmb_central_parities.vue?vue&type=script&route=%2Ffin%2Frmb_central_parities&lang=js"
export * from "./rmb_central_parities.vue?vue&type=script&route=%2Ffin%2Frmb_central_parities&lang=js"
import style0 from "./rmb_central_parities.vue?vue&type=style&index=0&id=64c0a08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c0a08e",
  null
  
)

export default component.exports